export default "__VITE_ASSET__CBOB6sVn__";